import type { ElementType, HTMLAttributes } from 'react';
import './Stack.css';

/** Spacing steps available to layout primitives — map 1:1 to `var(--spacing-N)`. */
export type LayoutGap = '0' | '1' | '2' | '3' | '4' | '6' | '8' | '12';
export type StackAlign = 'stretch' | 'start' | 'center' | 'end';

export interface StackProps extends HTMLAttributes<HTMLElement> {
  /** Vertical gap between children, `var(--spacing-{gap})`. Defaults to '4'. */
  gap?: LayoutGap;
  /** Cross-axis (horizontal) alignment of children. Defaults to 'stretch'. */
  align?: StackAlign;
  /** Element to render. Defaults to 'div'. */
  as?: ElementType;
  className?: string;
}

/**
 * Stack — vertical flex layout with token-based gap.
 * Use it instead of ad-hoc `display:flex; flex-direction:column; gap:…` wrappers.
 */
export function Stack({
  gap = '4',
  align = 'stretch',
  as: Tag = 'div',
  className = '',
  children,
  ...rest
}: StackProps) {
  const classes = ['rg-stack', `rg-stack--gap-${gap}`, `rg-stack--align-${align}`, className]
    .filter(Boolean)
    .join(' ');
  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}

export default Stack;
